import React from "react";
import {
    FormControl,
    FormLabel,
    Box,
  } from '@chakra-ui/react'
import { CustomReadOnlyInputProps } from "../../../types/form";

export default function ReadOnlyInput({ 
    label, 
    value, 
    id,  
    size,
    className,
    ...props
}: CustomReadOnlyInputProps) {
    return (
        <FormControl className={className}>
            <FormLabel 
                htmlFor={id} 
                fontSize={'sm' || props.fontSize} 
                color='rgba(51, 65, 85, 1)' 
                marginBottom={'0.5' || props?.marginBottom}
            >
                {label}
            </FormLabel>
            <Box 
                fontSize={'sm' || props.fontSize} 
                borderRadius={'md'}
                borderWidth={'1px'}
                borderStyle='solid'
                borderColor={'gray.200'}
                padding='2'
                color={'gray.500'}
                cursor='not-allowed'
                {...props} 
            >{value}</Box>
        </FormControl>       
    )
}

